import { FC, PropsWithChildren } from 'react';
import styles from './AdvancedFilter.css';

interface IAdvancedFilterProps {
  dataTestId?: string;
}

export const AdvancedFilter: FC<PropsWithChildren<IAdvancedFilterProps>> = ({ dataTestId, children }) => {
  return (
    <div role="group" className={styles['container']} data-testid={dataTestId}>
      {children}
    </div>
  );
};
